package com.solevo.dist.repository.implementation.customer

import com.solevo.dist.application.models.Customer
import com.solevo.dist.network.api.customers.CustomerRemoteSource
import com.solevo.dist.repository.ApplicationCustomerRepository
import kotlinx.coroutines.flow.Flow

class CustomerRepository(
    private val customerRemoteSource: CustomerRemoteSource
): ApplicationCustomerRepository {
    override fun getCurrentCustomer(): Flow<Customer?> {
        return customerRemoteSource.currentCustomer()
    }

    override suspend fun getCustomer(): Customer? {
        return customerRemoteSource.customer().getOrNull()
    }
}